import React from 'react'
import { OverflowHidden as Hidden } from '@sentecacommerce-theme/lib'

export const OverflowHidden = () => {
  return <Hidden />
}
